import React from "react";
import "./hamburger.scss";
import Proptypes from "prop-types";

const Hamburger = ({ open, onClick }) => (
  <a
    className={`${open ? "icons--hamburger__close" : "icons--hamburger__open"}`}
    onClick={onClick}
  >
    <span />
    <span />
    <span />
  </a>
);

Hamburger.propTypes = {
  open: Proptypes.bool,
  onClick: Proptypes.func,
};
export default Hamburger;
